import { useEffect, useRef, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

export default function Content() {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("kredit"); 
    const dropDownRef = useRef<HTMLDivElement>(null);

    const handleOptionClick = (option: string) => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (dropDownRef.current && !dropDownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
            className="relative -bottom-5"
        >
            <form className="max-w-[360px] md:max-w-[658px] px-4 md:px-0 mx-auto font-poppinsRegular">
                <div className="bg-white rounded-lg border p-4 relative">
                    <div className="flex flex-col md:flex-row items-start md:items-center">
                        <h2 className="mr-8 text-sm whitespace-nowrap text-red-700 font-bold mb-2 md:mb-0">CARI PRODUK:</h2>
                        <div className="flex flex-col w-full mt-1 text-sm">
                            <div
                                onClick={() => setIsOpen(!isOpen)}
                                ref={dropDownRef}
                                className="flex items-center w-full cursor-pointer justify-between border-b border-gray-300 pb-2"
                            >
                                <span className="text-gray-700">{selectedOption}</span>
                                {isOpen ? (
                                    <IoIosArrowUp className="w-4 h-4 text-gray-600" />
                                ) : (
                                    <IoIosArrowDown className="w-4 h-4 text-gray-600" />
                                )}
                            </div>
                        </div>
                        <div className="mt-4 md:mt-0 md:ml-4 w-full md:w-auto">
                            <Link
                                to={`/produk?category=${selectedOption}`}
                                className="w-full md:w-auto text-white bg-bprDarkBlue py-2 px-4 rounded-lg text-sm hover:bg-blue-800"
                            >
                                CARI
                            </Link>
                        </div>
                    </div>
                </div>

                <AnimatePresence>
                    {isOpen && (
                        <motion.div
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                            className="absolute w-full max-w-[328px] md:max-w-[658px] bg-white border rounded-md shadow-lg z-10 mt-2" // Changed to absolute positioning
                        >
                            <ul className="text-gray-700 max-h-40 overflow-y-auto">
                                {["kredit", "tabungan", "deposito"].map((option, index) => (
                                    <li
                                        key={index}
                                        onClick={() => handleOptionClick(option)} // Menyimpan pilihan saat klik
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    >
                                        {option}
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    )}
                </AnimatePresence>
            </form>
        </motion.div>
    );
}
